import React from "react";
import { useDoubleTap } from "use-double-tap";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  doubleClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export function DoubleClickable(props: Props) {
  const bind = useDoubleTap(props.doubleClick);

  // HTML props, not including custom callback, to be sent to the div
  const divProps: Partial<Props> = {
    ...props,
  };
  delete divProps.doubleClick;

  return (
    <div {...divProps} {...bind}>
      {props.children}
    </div>
  );
}
